import React from 'react';
import PropTypes from 'prop-types';

import { DayContext } from '@/contexts/day';

import { useToday } from '@/hooks';

export default function DayContextProvider({ children }) {
  const today = useToday();

  return (
    <DayContext.Provider value={today}>
      {children}
    </DayContext.Provider>
  );
}

DayContextProvider.propTypes = {
  children: PropTypes.node,
};
